export default {"src":"/_next/static/media/vignette-interview.4069a626.svg","height":147,"width":286,"blurWidth":0,"blurHeight":0};